<template>
	<div class="card-transparent-container">
		<div class="action-info-card-contianer display-flex flex-column">
			<div class="card-title">{{ title }}</div>
			<div class="card-description">{{ data.description }}</div>
			<div @click="openInNewTab" class="card-link">{{ data.link_text }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ActionInfoCard',
	props: {
		data: { type: Object },
		title: { type: String },
	},
	methods: {
		openInNewTab() {
			window.open(this.data.link_address, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.card-transparent-container {
	padding: 50px 10px 50px 50px;
	// padding is big, so mouseleave event will not be triggered immidiately
}
.action-info-card-contianer {
	width: 100%;
	text-align: left;
	border-radius: 9px;
	padding: 17px 10px 20px 14px;
	box-shadow: var(--card-shadow);
	color: var(--primary-font-color);
	background-color: var(--bg-color);

	.card-title {
		font-size: 16px;
		font-weight: medium;
	}
	.card-description {
		font-size: 14px;
		font-weight: 300;
		margin: 12px 0px;
	}

	.card-link {
		cursor: pointer;
		font-size: 14px;
		text-decoration: underline;
		color: var(--primary-color);
	}
}
</style>
